  <div class="loading-overlay" [ngStyle]="{ display: resloverCalled || show ? 'block' : 'none' }">
    <div class="container">
      <div class="square">
        <div class="content">
          <div id="cover-spin">
            <div style="display: flex; align-items: center; justify-content: center">
              <div style="width: auto">
                <div class="spin-inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>